// Puro (sem Vue, sem axios) de proposito - pra dar pra testar isolado e
// pra ser a fonte unica de verdade de "quantas saidas esse no tem e qual e
// a chave/rotulo de cada uma", usado tanto pelo canvas (Drawflow so lida
// com numero de portas) quanto pelo validador de publicacao.
// Espelha exatamente o contrato de app/Services/Fluxo/MotorFluxo.php (Fase 2/B5)
// e o catalogo de app/Http/Controllers/Api/FluxoController@catalogoNos.

export const TIPOS_TERMINAIS = ['transferir', 'fim']
export const TIPOS_SEM_ENTRADA = ['inicio']

export function saidasDoNo(no) {
  const conteudo = no.conteudo || {}

  switch (no.tipo) {
    case 'inicio':
    case 'mensagem':
    case 'imagem':
    case 'captura':
    case 'aguardar':
      return [{ chave: 'default', rotulo: null }]

    case 'condicao':
      return [
        { chave: 'sim', rotulo: 'Sim' },
        { chave: 'nao', rotulo: 'Não' },
      ]

    case 'unidade':
      return [
        { chave: 'encontrada', rotulo: 'Unidade encontrada' },
        { chave: 'nao_encontrada', rotulo: 'Não encontrada' },
      ]

    case 'chamado_glpi':
      return [
        { chave: 'criado', rotulo: 'Chamado criado' },
        { chave: 'falhou', rotulo: 'Falhou' },
      ]

    case 'horario':
      return [
        { chave: 'dentro', rotulo: 'Dentro do horário' },
        { chave: 'fora', rotulo: 'Fora do horário' },
      ]

    case 'botoes':
      return (conteudo.botoes || []).map(botao => ({ chave: botao.id, rotulo: botao.titulo }))

    case 'lista':
      return (conteudo.secoes || []).reduce((acc, secao) => {
        (secao.linhas || []).forEach(linha => acc.push({ chave: linha.id, rotulo: linha.titulo }))
        return acc
      }, [])

    case 'transferir':
    case 'fim':
    case 'nota':
    default:
      return []
  }
}

// Espelho de MotorFluxo::TEXTOS_PADRAO_CHAMADO - usado quando o no foi
// criado antes desses campos existirem. Campo presente e vazio = nao envia.
export const TEXTOS_PADRAO_CHAMADO = {
  mensagem_aguarde: 'Estamos registrando seu chamado em nossa plataforma de atendimento, aguarde...',
  mensagem_sucesso: 'Seu chamado foi registrado com sucesso!\nNúmero do chamado: #{{glpi_chamado_id}}',
  mensagem_falha: 'Não conseguimos registrar seu chamado agora. Vamos tentar novamente e enviaremos o número assim que ele for aberto.',
}

export const SOLUCAO_PADRAO_CHAMADO = 'Atendimento realizado pelo WhatsApp.'

export const ROTULOS_ABRIR_CHAMADO = { aberto: 'Aberto', solucionado: 'Solucionado', fechado: 'Fechado' }

export function textoChamado(conteudo, campo) {
  return conteudo && conteudo[campo] !== undefined && conteudo[campo] !== null ? conteudo[campo] : TEXTOS_PADRAO_CHAMADO[campo]
}

export function novoConteudoPadrao(tipo) {
  switch (tipo) {
    case 'mensagem':
    case 'captura':
      return { texto: '' }
    case 'botoes':
      return { texto: '', botoes: [] }
    case 'lista':
      return { texto: '', texto_botao: 'Escolher', secoes: [] }
    case 'imagem':
      return { midia_id: null, nome_arquivo: '', legenda: '' }
    case 'unidade':
      return { texto: 'Informe o seu código do cliente:', texto_invalido: 'Código do cliente não encontrado. Confira e envie novamente.', max_tentativas: 3 }
    case 'chamado_glpi':
      return {
        titulo: 'WhatsApp - {{unidade_nome}} - {{contato.nome}}',
        descricao: '',
        tipo: 1,
        categoria_id: null,
        categoria_nome: '',
        urgencia: 3,
        incluir_conversa: true,
        entidade_id: null,
        campos_glpi: [],
        abrir_como: 'aberto',
        solucao: SOLUCAO_PADRAO_CHAMADO,
        ...TEXTOS_PADRAO_CHAMADO,
      }
    case 'condicao':
      return { variavel: '', operador: 'igual', valor: '' }
    case 'horario':
      return { departamento_id: null }
    case 'transferir':
      return { departamento_id: null }
    case 'aguardar':
      return { segundos: 60 }
    default:
      return {}
  }
}

/**
 * @returns {{noId: ?string, texto: string}[]} problemas em portugues, vazia
 * se ok pra publicar. noId aponta o no com problema (null quando e do fluxo
 * todo) - o editor usa pra destacar o no no canvas.
 */
export function validarFluxo(definicao) {
  const problemas = []
  const problema = (no, texto) => problemas.push({ noId: no ? no.id : null, texto })
  const nos = (definicao && definicao.nos) || []

  if (!nos.length) {
    problema(null, 'O fluxo não tem nenhum nó.')
    return problemas
  }

  const porId = {}
  nos.forEach(no => { porId[no.id] = no })

  const nosInicio = nos.filter(no => no.tipo === 'inicio')
  if (nosInicio.length > 1) {
    nosInicio.forEach(no => problema(no, `"${rotuloNo(no)}": o fluxo tem mais de um nó de Início - deixe só um.`))
  }

  if (!definicao.no_inicial || !porId[definicao.no_inicial]) {
    problema(null, 'Não há um nó de início definido.')
  }

  // destinos apontando pra nó inexistente
  nos.forEach(no => {
    saidasDoNo(no).forEach(saidaEsperada => {
      const saidaReal = (no.saidas || []).find(s => s.chave === saidaEsperada.chave)
      if (saidaReal && saidaReal.destino && !porId[saidaReal.destino]) {
        problema(no, `"${rotuloNo(no)}": saída "${saidaEsperada.rotulo || saidaEsperada.chave}" aponta pra um nó que não existe mais.`)
      }
    })
  })

  // saidas obrigatorias sem destino (nao terminal, todas as saidas esperadas precisam ir a algum lugar)
  nos.forEach(no => {
    if (TIPOS_TERMINAIS.includes(no.tipo) || no.tipo === 'nota') return
    const esperadas = saidasDoNo(no)
    esperadas.forEach(saidaEsperada => {
      const saidaReal = (no.saidas || []).find(s => s.chave === saidaEsperada.chave)
      if (!saidaReal || !saidaReal.destino) {
        problema(no, `"${rotuloNo(no)}": saída "${saidaEsperada.rotulo || saidaEsperada.chave}" não está conectada a nada.`)
      }
    })
  })

  // campos obrigatorios por tipo
  nos.forEach(no => {
    const c = no.conteudo || {}
    if (['mensagem', 'captura', 'botoes', 'lista', 'unidade'].includes(no.tipo) && !String(c.texto || '').trim()) {
      problema(no, `"${rotuloNo(no)}": texto vazio.`)
    }
    if (no.tipo === 'imagem' && !c.midia_id) {
      problema(no, `"${rotuloNo(no)}": nenhuma imagem enviada.`)
    }
    if (no.tipo === 'chamado_glpi' && ![1, 2].includes(Number(c.tipo))) {
      problema(no, `"${rotuloNo(no)}": escolha se o chamado é Incidente ou Requisição.`)
    }
    if (no.tipo === 'chamado_glpi' && !String(c.titulo || '').trim()) {
      problema(no, `"${rotuloNo(no)}": título do chamado vazio.`)
    }
    if (no.tipo === 'chamado_glpi') {
      (c.campos_glpi_obrigatorios || []).forEach(obrigatorio => {
        if (!(c.campos_glpi || []).some(campo => campo.chave_input === obrigatorio.chave_input)) {
          problema(no, `"${rotuloNo(no)}": preencha o campo "${obrigatorio.rotulo}" (obrigatório no GLPI).`)
        }
      })
    }
    if (no.tipo === 'botoes' && (!c.botoes || !c.botoes.length)) {
      problema(no, `"${rotuloNo(no)}": nenhum botão cadastrado.`)
    }
    if (no.tipo === 'lista' && (!c.secoes || !c.secoes.some(s => s.linhas && s.linhas.length))) {
      problema(no, `"${rotuloNo(no)}": nenhuma linha cadastrada.`)
    }
    if (no.tipo === 'lista') {
      // A Meta rejeita ("Parameter value is not valid") titulo de linha
      // acima de 24 caracteres - o maxlength do campo impede digitar mais,
      // mas nao encurta o que ja veio de antes (ex: fluxo criado antes
      // desse limite existir no editor).
      (c.secoes || []).forEach(secao => {
        (secao.linhas || []).forEach(linha => {
          if ((linha.titulo || '').length > 24) {
            problema(no, `"${rotuloNo(no)}": linha "${linha.titulo}" passa de 24 caracteres.`)
          }
        })
      })
    }
    if (no.tipo === 'captura' && !String(c.nome_variavel || '').trim()) {
      problema(no, `"${rotuloNo(no)}": defina em qual variável guardar a resposta.`)
    }
    if (no.tipo === 'condicao' && !String(c.variavel || '').trim()) {
      problema(no, `"${rotuloNo(no)}": defina qual variável comparar.`)
    }
    if ((no.tipo === 'horario' || no.tipo === 'transferir') && !c.departamento_id) {
      problema(no, `"${rotuloNo(no)}": selecione um departamento.`)
    }
  })

  // alcancabilidade a partir do no_inicial (BFS)
  if (definicao.no_inicial && porId[definicao.no_inicial]) {
    const alcancados = new Set()
    const fila = [definicao.no_inicial]
    while (fila.length) {
      const atualId = fila.shift()
      if (alcancados.has(atualId)) continue
      alcancados.add(atualId)
      const no = porId[atualId]
      if (!no) continue
      (no.saidas || []).forEach(s => {
        if (s.destino && !alcancados.has(s.destino)) fila.push(s.destino)
      })
    }

    nos.forEach(no => {
      if (no.tipo !== 'nota' && !alcancados.has(no.id)) {
        problema(no, `"${rotuloNo(no)}" nunca é alcançado a partir do início.`)
      }
    })

    const alcancaTerminal = [...alcancados].some(id => {
      const no = porId[id]
      return no && TIPOS_TERMINAIS.includes(no.tipo)
    })
    if (!alcancaTerminal) {
      problema(null, 'Nenhum caminho a partir do início chega a um nó "Transferir" ou "Fim" - a conversa nunca termina.')
    }
  }

  return problemas
}

function rotuloNo(no) {
  const conteudo = no.conteudo || {}
  return conteudo.texto ? (no.id + ' - ' + String(conteudo.texto).substring(0, 24)) : no.id
}
